/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl';

import Breadcrumbs from '@atlaskit/breadcrumbs/breadcrumbs';
import { BreadcrumbsCurrentItem } from '@atlaskit/breadcrumbs/breadcrumbs-current-item';
import { BreadcrumbsItem } from '@atlaskit/breadcrumbs/breadcrumbs-item';
import { cssMap, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

import { useHubBreadcrumbItems } from './hub-breadcrumbs-context';
import { messages } from './messages';

const styles = cssMap({
	container: {
		boxSizing: 'border-box',
		minWidth: 0,
		paddingBottom: token('space.300'),
		paddingLeft: token('space.300'),
		paddingRight: token('space.300'),
		width: '100%',
	},
});

export const HubBreadcrumbs = (): JSX.Element | null => {
	const intl = useIntl();
	const items = useHubBreadcrumbItems();
	const currentItem = items[items.length - 1];

	if (!currentItem) {
		return null;
	}

	return (
		<div css={styles.container} data-testid="hub-breadcrumbs-container">
			<Breadcrumbs
				ellipsisLabel={intl.formatMessage(messages.showMore)}
				label={intl.formatMessage(messages.label)}
				size="medium"
				testId="hub-breadcrumbs"
			>
				{items.slice(0, -1).map((item) => (
					<BreadcrumbsItem href={item.href} key={item.id} text={item.text} />
				))}
				<BreadcrumbsCurrentItem href={currentItem.href} text={currentItem.text} />
			</Breadcrumbs>
		</div>
	);
};
